import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import EHFUANOutputComponent from '../output/EHFUANOutputComponent';

const EHFUANInputComponent = ({ serviceId, serviceDetails, leadId, initialValues }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        initialValues={initialValues}
        banner={{ icon: 'pi-briefcase', title: 'Employment History (UAN)', subtitle: 'Fetch employment history from EPFO using UAN' }}
        fields={[
            { name: 'uan', label: 'UAN', icon: 'pi-id-card', placeholder: '12-digit UAN', maxLength: 12, inputMode: 'numeric', numeric: true, mono: true,
              regex: /^\d{12}$/, regexError: 'UAN must be exactly 12 digits' },
            { name: 'mobile', label: 'Mobile (optional)', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true, required: false },
            { name: 'pan', label: 'PAN (optional)', icon: 'pi-credit-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true, required: false },
            { name: 'employeeName', label: 'Employee Name (optional)', icon: 'pi-user', placeholder: 'Enter employee name', maxLength: 100, autoCapitalize: 'words', required: false },
        ]}
        endpoint={{
            path: '/tartan/uan-employment-history',
            bodyMapper: (v, sid, lid) => ({
                uan: v.uan,
                ...(v.mobile && { mobile: v.mobile }),
                ...(v.pan && { pan: v.pan }),
                ...(v.employeeName && { employee_name: v.employeeName.trim() }),
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="ehf-uan"
        submitLabel="Fetch UAN Employment"
        successSummary="UAN employment history fetched"
        errorSummary="UAN employment fetch failed"
        confirmHeader="Confirm UAN employment fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={EHFUANOutputComponent}
    />
);

export default EHFUANInputComponent;
